//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'form-inicio',
  data: () => {
    return {
      formulario: {
        nome: '',
        telefone: '',
        email: '',
        autorizo: true
      },
      errorNome: false,
      errorTelefone: false,
      errorEmail: false
    }
  },
  methods: {
    proxEtapa () {
      this.errorNome = false
      this.errorTelefone = false
      this.errorEmail = false
      let regexEmail = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
      if (this.formulario.nome === '') {
        this.errorNome = true
      } else if (this.formulario.telefone === '') {
        this.errorTelefone = true
      } else if (this.formulario.email === '' || !regexEmail.test(this.formulario.email)) {
        this.errorEmail = true
      } else {
        localStorage.setItem('inicio', true)
        this.$store.commit('formulario', this.formulario)
        localStorage.setItem('formulario', JSON.stringify(this.formulario))
        this.$router.push('/exercicio')
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    localStorage.setItem('inicio', false)
    next()
  }
}
